import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-32ce2ec2")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", {
      id: _ctx.randomIdentifier,
      innerHTML: _ctx.content
    }, null, 8, ["id", "innerHTML"])
  ]))
})